export const RAY_CAST_SET = 'RAY_CAST_SET';
export const RAY_CAST_INFLATED_SET = 'RAY_CAST_INFLATED_SET';
export const RAY_CAST_HELPER_SET = 'RAY_CAST_HELPER_SET';
export const RAY_CAST_HELPER_TOGGLE = 'RAY_CAST_HELPER_TOGGLE';